import React from 'react'
import SortableTable from '../../../_library/SortableTable/index'
import { getTableColumns } from '../../../utils/sortableTableUtils'

const RightSection = ({ event, ticketTypes, addOns, tableTypes }) => {
  const ticketColumns = getTableColumns(['name', 'price', 'stock'], event.currency.symbol)
  const addOnColumns = getTableColumns(['name', 'price', 'stock'], event.currency.symbol)
  const tableColumns = getTableColumns(['name', 'price', 'stock'], event.currency.symbol)

  if (!ticketTypes && !tableTypes && !addOns) return null

  const tables = [
    {
      label: 'Ticket Types',
      icon: 'tickets',
      data: ticketTypes,
      columns: ticketColumns,
      statuses: [{ key: 'active' }],
    },
    {
      label: 'Table Types',
      icon: 'tickets',
      data: tableTypes,
      columns: tableColumns,
      statuses: [{ key: 'active' }],
    },
    {
      label: 'Add-Ons',
      icon: 'add-ons',
      data: addOns,
      columns: addOnColumns,
      statuses: [
        {
          key: 'active',
          activeLabel: `This add-on is available for sale`,
          inactiveLabel: (
            <span>
              This add-on is <strong>not</strong> available for sale
            </span>
          ),
        },
      ],
    },
  ]

  const totalTickets = [...(ticketTypes || []), ...(tableTypes || [])].reduce(
    (acc, item) => acc + item.maxInventory,
    0,
  )

  const infoBlocks = [
    {
      id: 'totalTickets',
      value: totalTickets,
      label: 'Total Nº of tickets (All ticket types)',
    },
    {
      id: 'minimumAge',
      value: event.minimumAge || 'All Ages',
      label: 'Minimum age',
    },
    {
      id: 'invitationRequired',
      value: event.flagInvitationsOnly ? 'Yes' : 'No',
      label: 'Invitation required',
    },
  ]

  return (
    <div className="right-section col-xs-9" style={{ marginTop: 35 }}>
      <div>
        <span>
          <img
            src={asset(`/resources/images/system_icons/ticket-buyer.svg`)}
            alt="nodata"
            style={{ width: 15, height: 15, margin: '10px 10px 10px 0' }}
          />
          Tickets Schedule
        </span>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
          }}
        >
          {infoBlocks.map(item => (
            <div key={item.id}>
              <span style={{ color: '#B0B6C0' }}>{item.label}</span>
              <p>{item.value}</p>
            </div>
          ))}
        </div>
      </div>
      {tables.map(item =>
        item.data && item.data.length ? (
          <div key={item.label} style={{ marginBottom: 15 }}>
            <span>
              <img
                src={asset(`/resources/images/system_icons/${item.icon}.svg`)}
                alt="nodata"
                style={{ width: 15, height: 15, margin: '10px 10px 10px 0' }}
              />
              {item.label}
            </span>
            <SortableTable
              rowTableClass="scrollable"
              tableColumns={item.columns}
              data={item.data}
              statuses={item.statuses || []}
              disableMobileView={true}
            />
          </div>
        ) : null,
      )}
    </div>
  )
}

export default RightSection
